import { Wallet, DollarSign, CheckCircle2, Hourglass } from "lucide-react";
import { EmptyState } from "@/components/EmptyState";
import { StatCard } from "@/components/StatCard";
import { useI18n } from "@/i18n/I18nProvider";
import { formatMoney } from "@/lib/api";
import { useMySummary } from "@/pages/employee/MyDashboard";

export default function MyEarnings() {
  const { t, lang } = useI18n();
  const { data, error } = useMySummary();
  const v = (x) => (data ? formatMoney(x, lang) : "—");
  return (
    <div>
      <h1 data-testid="my-earnings-title" className="mb-6 font-display text-2xl font-extrabold text-[#000B45]">{t("portal.earningsTitle")}</h1>
      {error && <p className="mb-4 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{t(error)}</p>}
      <div className="grid grid-cols-1 gap-3">
        <StatCard testId="earn-gross" label={t("portal.gross")} value={v(data?.gross_earned)} icon={DollarSign} />
        <StatCard testId="earn-paid" label={t("portal.paid")} value={v(data?.paid)} icon={CheckCircle2} />
        <StatCard testId="earn-pending" label={t("portal.pending")} value={v(data?.pending)} icon={Hourglass} accent />
      </div>
      <div className="mt-6">
        <EmptyState testId="my-payments-empty" icon={Wallet} title={t("portal.earningsEmpty")} />
      </div>
    </div>
  );
}
